import { useEffect } from 'react';


export function useMarkNotificationsRead(notifications = []) {
    return useEffect(() => {
        let timeout = setTimeout(() => {
            for (let n of notifications) app.api.notifications.markRead(n.id);
        }, 1250);
        return () => clearTimeout(timeout);
    }, [notifications]);
}
